import React from "react";

type IconProps = {
  className?: string;
};

export const CloseIcon = ({ className = "" }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    className={className}
  >
    <path
      d="M7.06875 6.2687L0.96875 0.168701C0.74375 -0.0562988 0.39375 -0.0562988 0.16875 0.168701C-0.0562498 0.393701 -0.0562498 0.7437 0.16875 0.9687L6.26875 7.0687L0.16875 13.1687C-0.05625 13.3937 -0.05625 13.7437 0.16875 13.9687C0.39375 14.1937 0.74375 14.1937 0.96875 13.9687L7.06875 7.8687L13.1688 13.9687C13.3938 14.1937 13.7438 14.1937 13.9688 13.9687C14.0688 13.8687 14.1438 13.7187 14.1438 13.5687C14.1438 13.4187 14.0938 13.2687 13.9688 13.1687L7.86875 7.0687L13.9688 0.968701C14.0688 0.868701 14.1438 0.718701 14.1438 0.568701C14.1438 0.418701 14.0938 0.268701 13.9688 0.168701C13.7438 -0.0562987 13.3938 -0.0562987 13.1688 0.168701L7.06875 6.2687Z"
      fill="#637381"
    />
  </svg>
);

export const ChevronIcon = ({ className = "" }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="8"
    viewBox="0 0 15 8"
    fill="currentColor"
    className={className}
  >
    <path d="M13.5773 7.64297C13.4086 7.64297 13.268 7.58672 13.1273 7.47422L7.10859 1.53984L1.08984 7.44609C0.836719 7.69922 0.442969 7.69922 0.189844 7.44609C-0.0632813 7.19297 -0.0632813 6.79922 0.189844 6.54609L6.65859 0.189844C6.91172 -0.0632813 7.30547 -0.0632813 7.55859 0.189844L14.0273 6.54609C14.2805 6.79922 14.2805 7.19297 14.0273 7.44609C13.9148 7.55859 13.7461 7.64297 13.5773 7.64297Z" />
  </svg>
);

export const CheckMarkIcon = ({ className = "" }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="7"
    viewBox="0 0 10 7"
    fill="none"
    className={className}
  >
    <path
      d="M8.82812 0.341309C8.98648 0.177324 9.2297 0.155838 9.40918 0.278809L9.48145 0.340332L9.4873 0.346191L9.49219 0.352051C9.64183 0.533081 9.64301 0.816059 9.44922 0.998535L9.4502 0.999512L4.11426 6.35596L4.11523 6.35693C3.96068 6.51694 3.76294 6.60006 3.54785 6.6001C3.34993 6.6001 3.13589 6.5189 2.97949 6.35693V6.35596L0.334961 3.69385L0.333008 3.69189C0.156104 3.50842 0.15599 3.21906 0.333008 3.03564C0.513296 2.84894 0.803246 2.84842 0.984375 3.03369L3.5625 5.62939L8.82812 0.341309Z"
      fill="#012169"
      stroke="#012169"
      strokeWidth="0.4"
    />
  </svg>
);

export const DisplayIcon = ({ className = "" }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    className={className}
  >
    <path
      d="M15.7777 2.6438H2.22148C1.26523 2.6438 0.505859 3.40317 0.505859 4.35942V10.7719C0.505859 11.7282 1.26523 12.4875 2.22148 12.4875H8.38086V14.0907H6.15898C5.82148 14.0907 5.51211 14.3719 5.51211 14.7375C5.51211 15.1032 5.79336 15.3844 6.15898 15.3844H11.8965C12.234 15.3844 12.5434 15.1032 12.5434 14.7375C12.5434 14.3719 12.2621 14.0907 11.8965 14.0907H9.67461V12.4875H15.834C16.7902 12.4875 17.5496 11.7282 17.5496 10.7719V4.35942C17.5215 3.40317 16.734 2.6438 15.7777 2.6438ZM16.2559 10.7719C16.2559 11.025 16.059 11.2219 15.8059 11.2219H2.22148C1.96836 11.2219 1.77148 11.025 1.77148 10.7719V4.35942C1.77148 4.1063 1.96836 3.90942 2.22148 3.90942H15.8059C16.059 3.90942 16.2559 4.1063 16.2559 4.35942V10.7719Z"
      fill="#637381"
    />
  </svg>
);

export const ArrowIcon = ({ className = "" }: IconProps) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M16.2 8.55001L10.3781 2.64376C10.125 2.39064 9.73126 2.39064 9.47813 2.64376C9.22501 2.89689 9.22501 3.29064 9.47813 3.54376L14.2031 8.35314H2.25001C1.91251 8.35314 1.63126 8.63439 1.63126 8.97189C1.63126 9.30939 1.91251 9.61876 2.25001 9.61876H14.2594L9.47813 14.4844C9.22501 14.7375 9.22501 15.1313 9.47813 15.3844C9.59063 15.4969 9.75938 15.5531 9.92813 15.5531C10.0969 15.5531 10.2656 15.4969 10.3781 15.3563L16.2 9.45001C16.4531 9.19689 16.4531 8.80314 16.2 8.55001Z"
      fill={"#637381"}
    />
  </svg>
);

export const FavoritesIcon = ({ className = "" }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="23"
    viewBox="0 0 23 23"
    className={className}
  >
    <path
      d="M11.3291 0.333008C11.7745 0.33306 12.196 0.563063 12.4336 0.938477L12.5234 1.1084L12.5283 1.11914L15.1533 6.59375L15.2295 6.75195L15.4023 6.7793L21.1719 7.67871C21.6642 7.77255 22.0768 8.10792 22.2227 8.57422L22.2275 8.58594C22.4066 9.09338 22.2596 9.63586 21.8936 10.002L21.8877 10.0068L17.7256 14.3574L17.6113 14.4766L17.6377 14.6406L18.6123 20.7148V20.7178C18.7041 21.2694 18.492 21.7735 18.0439 22.0723L18.0352 22.0791C17.614 22.3798 17.1117 22.4088 16.6602 22.168L11.4883 19.3574L11.3291 19.2705L11.1699 19.3574L5.99512 22.1699L5.98145 22.1768L5.96875 22.1855C5.82805 22.2791 5.61061 22.3164 5.36621 22.3164C5.09972 22.3164 4.82996 22.2268 4.62305 22.0791C4.19527 21.7735 3.95638 21.223 4.04492 20.7207L4.0459 20.7158L5.02051 14.6777L5.04688 14.5127L4.93066 14.3926L0.730469 10.0801L0.727539 10.0771L0.604492 9.93457C0.344837 9.58611 0.262742 9.11313 0.397461 8.64941C0.529239 8.22786 0.868119 7.90409 1.26172 7.79102L1.43262 7.75586L1.44434 7.75391L7.25684 6.81641L7.42969 6.78906L7.50488 6.63086L10.127 1.12402C10.3767 0.624552 10.8311 0.333008 11.3291 0.333008ZM11.0273 1.58301L8.32715 7.32031L8.32422 7.32715C8.22116 7.55895 7.97867 7.75224 7.70605 7.80859L1.64062 8.74512L1.3584 8.78906V9.28516L1.45312 9.38281L5.83984 13.8828L5.84277 13.8857C6.0176 14.0606 6.11127 14.3607 6.08496 14.6553L5.0752 20.9092L5.07031 20.9355V21.5596L5.5625 21.293L10.9629 18.3682L10.9658 18.3662C11.1968 18.2379 11.491 18.2297 11.7764 18.3711L17.1699 21.293L17.6621 21.5596V20.9355L17.6582 20.9092L16.6455 14.6094L16.6436 14.5967L16.6318 14.5049C16.6199 14.2869 16.7133 14.0493 16.9043 13.8311L21.2764 9.34766L21.2773 9.34863C21.3279 9.29804 21.3677 9.23062 21.3838 9.15039C21.3994 9.07257 21.3884 9.00405 21.3721 8.95508C21.3563 8.90796 21.3341 8.87268 21.3184 8.85059C21.3101 8.83901 21.3016 8.82906 21.2949 8.82129C21.2915 8.81739 21.2881 8.81367 21.2852 8.81055C21.2837 8.80899 21.2826 8.80704 21.2812 8.80566L21.2783 8.80273H21.2773V8.80176L21.2002 8.72461L21.0928 8.70801L15.0625 7.77148C14.7751 7.71213 14.5495 7.54672 14.4512 7.30078L14.4463 7.28906L14.4404 7.27734L11.6279 1.57715L11.3223 0.957031L11.0273 1.58301Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.666667"
    />
  </svg>
);

export const FavoritesFilledIcon = ({ className = "" }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
  >
    <path
      d="M12.0361 1.63477C12.0459 1.64075 12.0612 1.65413 12.0762 1.68262L15.1494 8.12793L15.2637 8.36621L15.5244 8.40625L22.3115 9.45703H22.3125C22.3282 9.45947 22.3348 9.46385 22.3408 9.46973C22.3495 9.47814 22.363 9.49632 22.3721 9.52734C22.3812 9.5588 22.3826 9.59397 22.377 9.62402C22.3721 9.64951 22.3624 9.66554 22.3545 9.67578L17.4541 14.7266L17.2793 14.9072L17.3203 15.1562L18.4824 22.2432L18.4863 22.2637L18.4912 22.2842C18.4899 22.2873 18.484 22.2988 18.4678 22.3105C18.4515 22.3223 18.4336 22.3277 18.4199 22.3291C18.4088 22.3302 18.3995 22.3286 18.3896 22.3232L12.3164 18.9863L12.0762 18.8545L11.8359 18.9863L5.72363 22.3232L5.7041 22.334L5.68652 22.3467C5.66989 22.3578 5.65823 22.3618 5.65332 22.3633C5.65084 22.364 5.64921 22.3642 5.64844 22.3643H5.64746L5.64551 22.3633C5.64375 22.3626 5.64047 22.361 5.63574 22.3574C5.61332 22.3406 5.58765 22.2999 5.59473 22.2432L6.75684 15.1562L6.79785 14.9072L6.62207 14.7266L1.70996 9.66406L1.69824 9.65234L1.68555 9.64062L1.66504 9.61719C1.66037 9.60938 1.65727 9.60155 1.65527 9.59375C1.6507 9.57576 1.65127 9.55256 1.6582 9.52832C1.66526 9.50388 1.67712 9.4853 1.68848 9.47461C1.69785 9.46582 1.7089 9.45982 1.72656 9.45703L1.72559 9.45605L8.47461 8.44434L8.73828 8.40527L8.85254 8.16406L11.9229 1.68652C11.9384 1.6555 11.9547 1.64105 11.9648 1.63477C11.9762 1.62779 11.9889 1.625 12.001 1.625C12.0129 1.62501 12.025 1.62801 12.0361 1.63477Z"
      fill="currentColor"
      stroke="currentColor"
    />
  </svg>
);

export const DoubleDownIcon = ({ className = "" }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="11"
    viewBox="0 0 13 11"
    fill="none"
    className={className}
  >
    <path
      d="M6.71875 3.40005C6.61875 3.30005 6.46875 3.25005 6.31875 3.25005C6.16875 3.25005 6.04375 3.30005 5.91875 3.40005L0.16875 9.05005C-0.0562505 9.27505 -0.0562505 9.62505 0.16875 9.85005C0.39375 10.075 0.743749 10.075 0.968749 9.85005L6.31875 4.60005L11.6687 9.85005C11.8937 10.075 12.2437 10.075 12.4687 9.85005C12.6937 9.62505 12.6937 9.27505 12.4687 9.05005L6.71875 3.40005Z"
      fill="#012169"
    />
    <path
      d="M0.968749 6.60005L6.31875 1.35005L11.6687 6.60005C11.8937 6.82505 12.2437 6.82505 12.4687 6.60005C12.6937 6.37505 12.6937 6.02505 12.4687 5.80005L6.71875 0.150048C6.61875 0.0500483 6.46875 4.85749e-05 6.31875 4.85618e-05C6.16875 4.85487e-05 6.04375 0.0500483 5.91875 0.150048L0.16875 5.80005C-0.0562505 6.02505 -0.0562505 6.37505 0.16875 6.60005C0.39375 6.82505 0.743749 6.82505 0.968749 6.60005Z"
      fill="#012169"
    />
  </svg>
);

export const SaveIcon = ({ className = "" }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    className={className}
  >
    <path
      d="M16.9688 3.0625L13.9375 0.28125L13.875 0.25C13.6563 0.09375 13.4063 0 13.1875 0H2.375C1.0625 0 0 1.0625 0 2.375V16.5C0 17.8125 1.0625 18.875 2.375 18.875H14.9375C16.25 18.875 17.3125 17.8125 17.3125 16.5V3.875C17.3125 3.59375 17.2188 3.3125 16.9688 3.0625ZM11.125 1.4375V3.21875H4.59375V1.4375H11.125ZM5.375 17.5312V11.75H11.9375V17.5H5.375V17.5312ZM15.9063 16.5312C15.9063 17.0625 15.4688 17.5 14.9375 17.5H13.3438V11.4688C13.3438 10.875 12.8438 10.375 12.25 10.375H5.0625C4.46875 10.375 3.96875 10.875 3.96875 11.4688V17.5312H2.375C1.84375 17.5312 1.40625 17.0938 1.40625 16.5625V2.40625C1.40625 1.875 1.84375 1.4375 2.375 1.4375H3.1875V3.53125C3.1875 4.125 3.6875 4.625 4.28125 4.625H11.4375C12.0313 4.625 12.5313 4.125 12.5313 3.53125V1.4375H13.0938L15.9063 4.03125V16.5312V16.5312Z"
      fill="white"
    />
    <path
      d="M9.9375 12.75H7.375C7 12.75 6.65625 13.0625 6.65625 13.4687C6.65625 13.875 6.96875 14.1875 7.375 14.1875H9.9375C10.3125 14.1875 10.6562 13.875 10.6562 13.4687C10.6562 13.0625 10.3125 12.75 9.9375 12.75Z"
      fill="white"
    />
    <path
      d="M9.9375 15.125H7.375C7 15.125 6.65625 15.4375 6.65625 15.8438C6.65625 16.25 6.96875 16.5625 7.375 16.5625H9.9375C10.3125 16.5625 10.6562 16.25 10.6562 15.8438C10.6562 15.4375 10.3125 15.125 9.9375 15.125Z"
      fill="white"
    />
  </svg>
);

export const TrashIcon = ({ className = "" }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="23"
    viewBox="0 0 17 23"
    fill="none"
    className={className}
  >
    <path
      d="M6.90039 0.333008L9.78711 0.333008C10.728 0.333008 11.4795 1.08449 11.4795 2.02539V2.99609H14.7002C15.6076 2.9962 16.3544 3.75064 16.3545 4.6123V5.7373C16.3545 6.38782 15.9498 6.98137 15.3584 7.23047L15.165 7.31152L15.1543 7.52051L14.4795 20.5332V20.54C14.4475 21.5551 13.5873 22.3914 12.5254 22.3916H4.08789C3.09687 22.3916 2.30199 21.6921 2.15332 20.7266L2.13281 20.5303L1.5332 7.55957L1.52344 7.34961L1.3291 7.26758C0.734383 7.01704 0.33316 6.4595 0.333008 5.77539L0.333008 4.65039C0.333008 3.74705 1.08399 2.9962 1.9873 2.99609L5.20801 2.99609V2.02539C5.20801 1.08449 5.95949 0.333008 6.90039 0.333008ZM2.62988 7.77832L3.22949 20.4902V20.4893C3.23753 20.9804 3.65966 21.3709 4.16211 21.3711H12.5625C13.079 21.3711 13.4732 20.9722 13.5303 20.5166L13.5322 20.5039L13.5332 20.4902L14.1328 7.77832L14.1494 7.42871L2.61328 7.42871L2.62988 7.77832ZM2.02539 4.0166C1.62709 4.0166 1.3916 4.34419 1.3916 4.65039L1.3916 5.77539C1.39182 6.17346 1.71929 6.4082 2.02539 6.4082L14.7002 6.4082C15.0982 6.4081 15.3328 6.08143 15.333 5.77539V4.65039C15.333 4.25217 15.0063 4.0167 14.7002 4.0166L2.02539 4.0166ZM6.9375 1.35449C6.56591 1.35449 6.2666 1.65379 6.2666 2.02539V2.3584H6.30371V2.99609H10.4961V2.02539C10.4961 1.65386 10.1967 1.3546 9.8252 1.35449L6.9375 1.35449Z"
      fill="#637381"
      stroke="#637381"
      strokeWidth="0.666667"
    />
    <path
      d="M8.3625 11.0251C7.9125 11.0251 7.5 11.4001 7.5 11.8876V17.7001C7.5 18.1501 7.875 18.5626 8.3625 18.5626C8.8125 18.5626 9.225 18.1876 9.225 17.7001V11.8501C9.225 11.4001 8.8125 11.0251 8.3625 11.0251Z"
      fill="#637381"
    />
    <path
      d="M11.8502 11.7375C11.4002 11.7 10.9877 12.075 10.9502 12.525L10.7252 16.8375C10.6877 17.2875 11.0627 17.7 11.5127 17.7375H11.5502C12.0002 17.7375 12.3752 17.4 12.3752 16.95L12.6002 12.6375C12.6752 12.15 12.3002 11.775 11.8502 11.7375Z"
      fill="#637381"
    />
    <path
      d="M4.83696 11.7375C4.38696 11.775 4.01196 12.15 4.04946 12.6375L4.31196 16.9875C4.34946 17.4375 4.72446 17.775 5.13696 17.775H5.17446C5.62446 17.7375 5.99946 17.3625 5.96196 16.875L5.73696 12.525C5.69946 12.075 5.28696 11.7 4.83696 11.7375Z"
      fill="#637381"
    />
  </svg>
);
